import menu from './menu';
import auth from './auth';
import popup from './popup';
import notifications from './notifications';
import app from './app';
import table from './table';
import users from './users';
import objects from './objects';
import devices from './devices';
import apps from './apps';
import datasets from './datasets';
import media from './media';
import drivers from './drivers';
import schemas from './schemas';
import logs from './logs';

export default {
  menu: menu(),
  auth,
  popup,
  notifications,
  app,
  table,
  users,
  objects,
  devices,
  apps,
  datasets,
  media,
  drivers,
  schemas,
  logs
};
